import InputIcon from '@mui/icons-material/Input';
import OutputIcon from '@mui/icons-material/Output';
import ComputerIcon from '@mui/icons-material/Computer';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { GoContainer } from 'react-icons/go';
import { VscTerminalCmd } from 'react-icons/vsc';
import { AiOutlineContainer } from 'react-icons/ai';
import { PiFilmScriptBold } from 'react-icons/pi';

export const WORKFLOW_CONSTANTS = {
    DEFAULT_WORKFLOW_NAME: 'New_Workflow',

    EXPORT_FORMAT: 'yaml',

    MIN_NAME_LENGTH: 4,
    NAME_REGEX: /^[a-zA-Z0-9_]{4}[a-zA-Z0-9_]*$/,

    TOAST_CONFIG: {
        SUCCESS: {
            position: 'bottom-right' as const,
            theme: 'colored' as const,
            autoClose: 1000,
        },
        ERROR: {
            position: 'bottom-right' as const,
            theme: 'colored' as const,
            autoClose: 2000,
        },
        ERROR_LONG: {
            position: 'bottom-right' as const,
            theme: 'colored' as const,
            autoClose: 3000,
        },
    },

    FAB_POSITIONS: {
        ADD: { right: 20, top: 20 },
        SAVE: { right: 20, top: 90 },
        DOWNLOAD: { right: 20, top: 160 },
    },

    Z_INDEX: {
        FAB: 1000,
    },
};

export const ERROR_MESSAGES = {
    WORKFLOW_NAME_REQUIRED: 'Workflow name is required',
    WORKFLOW_NAME_TOO_SHORT: 'Workflow name must be at least 4 characters long',
    WORKFLOW_NAME_INVALID_FORMAT: 'Workflow name can only contain letters, numbers, and underscores',
    WORKFLOW_NAME_DUPLICATE: 'A workflow with this name already exists. Please choose a different name.',
    WORKFLOW_NOT_FOUND: 'Workflow not found',
    WORKFLOW_INSTANCE_NOT_FOUND: 'Workflow instance not found',
    ERROR_LOADING_WORKFLOW: 'Error loading workflow',
    ERROR_SAVING_WORKFLOW: 'Error saving workflow',
    ERROR_GENERATING_FILE: 'Error generating file',
    ERROR_DELETE_WORKFLOW: 'Failed to delete workflow',
    ERROR_PROJECTS: 'No projects available for the user.',
    WORKFLOW_COMPONENTS_MISSING: 'Workflow must contain at least one component',
    PROVIDE_WORKFLOW_NAME: 'Please provide a workflow name before running',
    WORKFLOW_VALIDATION_FAILED:
        'Workflow validation failed. The generated YAML has syntax errors. Please check your workflow configuration and try again.',
    FAILED_TO_CONVERT_WORKFLOW: 'Failed to convert workflow to YAML format. Please check your workflow configuration.',
};

export const SUCCESS_MESSAGES = {
    WORKFLOW_LOADED: 'Workflow loaded successfully',
    WORKFLOW_CREATED: 'New workflow created successfully',
    WORKFLOW_UPDATED: 'Workflow updated successfully',
    FILE_DOWNLOADED: 'YAML File Downloaded',
    WORKFLOW_DELETED: 'Workflow deleted successfully',
    REQUEST: 'Requested successfully.',
};

export const exportFormat = 'yaml';

export const resourceTypeGeneral = [
    'Audiovisual',
    'Book',
    'BookChapter',
    'Collection',
    'ComputationalNotebook',
    'ConferencePaper',
    'ConferenceProceeding',
    'DataPaper',
    'Dataset',
    'Dissertation',
    'Event',
    'Image',
    'InteractiveResource',
    'Instrument',
    'Journal',
    'JournalArticle',
    'Model',
    'OutputManagementPlan',
    'PeerReview',
    'PhysicalObject',
    'Preprint',
    'Report',
    'Service',
    'Software',
    'Sound',
    'Standard',
    'StudyRegistration',
    'Text',
    'Workflow',
    'Other',
];

export const SORT_BY_NAME = 'name';
export const SORT_BY_DATE = 'date';

export const REACT_APP_DEVELOP_LEXIS_URL = process.env.REACT_APP_DEVELOP_LEXIS_URL;
export const computationNodes = [
    {
        type: 'hpcJob',
        connectionType: 'default',
        icon: ComputerIcon,
        title: 'HPC Job',
        description: 'Execute high-performance computing tasks',
        className: 'computation',
    },
    {
        type: 'containerJob',
        connectionType: 'default',
        icon: AiOutlineContainer,
        title: 'Container Job',
        description: 'Execute container tasks',
        className: 'computation',
    },
    {
        type: 'jobscriptJob',
        connectionType: 'default',
        icon: PiFilmScriptBold,
        title: 'Jobscript Job',
        description: 'Execute jobscript tasks',
        className: 'computation',
    },
];

export const inputNodes = [
    {
        type: 'datasetInput',
        connectionType: 'input',
        icon: InputIcon,
        title: 'Dataset Input',
        description: 'Source node for input datasets',
        className: 'input',
    },
    {
        type: 'containerInput',
        connectionType: 'input',
        icon: GoContainer,
        title: 'Container Input',
        description: 'Source node for container datasets',
        className: 'input',
    },
    {
        type: 'jobscriptInput',
        connectionType: 'input',
        icon: VscTerminalCmd,
        title: 'JobScript Input',
        description: 'Source node for jobScript input',
        className: 'input',
    },
];

export const outputNodes = [
    {
        type: 'datasetOutput',
        connectionType: 'output',
        icon: OutputIcon,
        title: 'Dataset Output',
        description: 'Simple output node for datasets',
        className: 'output',
    },
    {
        type: 'datasetOutputIrods',
        connectionType: 'output',
        icon: CloudUploadIcon,
        title: 'Dataset Output (iRODS)',
        description: 'Output node with iRODS upload capabilities',
        className: 'output',
    },
];
